<template>
  <v-dialog
    v-model="show"
    transition="slide-y-reverse-transition"
    persistent
    overlay-opacity=".9"
    style="z-index: 9999"
  >
    <v-card 
      class="pt-3 black"
    >
      <v-card-title>{{ $t('update.title') }}</v-card-title>
      <v-card-text class="py-4">
        <p 
          class="body-1"
          v-html="formatText($t('update.subtitle'))"
        />
        <p 
          class="body-1"
          v-html="formatText($t('update.text'))"
        />
      </v-card-text>

      <v-card-actions class="pb-4">
        <v-btn
          v-if="!forced"
          text
          class="text--secondary"
          @click="dismiss"
        >
          {{ $t('update.later') }}
        </v-btn>
        <v-spacer />
        <v-btn
          text
          color="primary"
          class="accent--text"
          @click="openAppStore"
        >
          {{ $t('update.cta') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
</style>

<script>
  import services from '@/services.js'

  export default {
    props: {
      toggle: {
        type: Boolean,
        default: false
      },
      forced: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      show: false
    }),

    watch: {
      toggle: {
        immediate: true,
        handler (b) {
          this.show = Boolean(b);
        }
      },
      show (b) {
        // Forced updates cannot be dismissed
        if (!b && this.forced) {
          this.show = true;
          return;
        }
        if (!b) this.$emit('toggle', b);
      }
    },

    methods: {
      ...services,

      dismiss () {
        if (this.forced) return;
        this.show = false;
      },

      openAppStore () {
        window.location = 'https://play.google.com/store/apps/details?id=br.com.mobees.parceiro';
      },
    }
  }
</script>